import styled from "styled-components";
import { theme } from "@ifgengineering/component-library";
import React from "react";

export const Container = styled.div<{
  gap?: number;
  direction?: string;
  padding?: string;
  alignItems?: string;
  justifyContent?: string;
  backgroundColor?: string;
  borderBottomLeftRadius?: string;
  borderBottomRightRadius?: string;
  borderTopLeftRadius?: string;
  borderTopRightRadius?: string;
}>`
  display: flex;
  flex-direction: ${({ direction = "column" }) => direction};
  gap: ${({ gap }) => (gap ? `${gap}px` : "8px")};
  padding: ${({ padding = "0" }) => padding};
  align-items: ${({ alignItems }) => alignItems};
  justify-content: ${({ justifyContent }) => justifyContent};
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-bottom-left-radius: ${({ borderBottomLeftRadius }) =>
    borderBottomLeftRadius};
  border-bottom-right-radius: ${({ borderBottomRightRadius }) =>
    borderBottomRightRadius};
  border-top-left-radius: ${({ borderTopLeftRadius }) => borderTopLeftRadius};
  border-top-right-radius: ${({ borderTopRightRadius }) =>
    borderTopRightRadius};
`;

export const TermsLink = styled.a`
  text-decoration: underline;
`;

export const Link = styled.a<{ fontSize?: string }>`
  color: ${theme.colors.BLUE600};
  font-size: ${({ fontSize }) => fontSize || "16px"};
  font-weight: 500;
  cursor: pointer;
`;

export const ForgotPassword = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${theme.colors.BLUE600};
  cursor: pointer;
  text-align: right;
`;

export const BackContainer = styled.a`
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  cursor: pointer;
  width: fit-content;
`;

export const StyledLine = styled.hr`
  width: 100%;
  height: 0;
  border-top: 1px solid ${theme.colors.SLATE300};
`;

export const TextDivider = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 16px;
  align-items: center;
  justify-content: center;
  padding: 0 9.5px;
  text-align: center;
`;

export const OutlineButton = styled.button`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${theme.colors.WHITE};
  color: ${theme.colors.SLATE700};
  font-size: 14px;
  height: 48px;
  gap: 8px;

  &:hover {
    background-color: ${theme.colors.SLATE100};
  }

  &:active {
    border-color: ${theme.colors.BLUE300};
  }

  img {
    max-width: 18px;
  }
`;

export const OutlineButtonWithImage: React.FC<{
  text: string;
  image?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  testId: string;
  type?: "button" | "submit" | "reset";
}> = ({ text, image, onClick, testId, type }) => {
  return (
    <OutlineButton onClick={onClick} data-testid={testId} type={type}>
      {image && <img src={image} alt="Image" />}
      {text}
    </OutlineButton>
  );
};
